// Minimal global JavaScript

class Theme {
  constructor() {
    this.init();
  }

  init() {
    // Add any global theme initialisation here
    console.log('Theme initialised');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Theme();
});
